import { T_Product } from '../types';

export let getProductImageUrl = (product: T_Product) => {
  // use custom1 field for product image
  return product?.custom1;
};
